import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import { MultipleImageUploader, Typography } from "@maysoft/common-component-react";

import Constants from "constants/index";
import Strings from "constants/strings";

import { Mode } from "constants/enum";
import { IDataDetailReport } from "commons/interfaces";



const CardPhotoReport = ({
    mode,
    data,
    handleChangeValue,
}: {
    mode: Mode,
    data: IDataDetailReport;
    handleChangeValue: (key: string, value: any) => void;
}) => {

    return (
        <Card sx={{ padding: 3 }}>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Typography variant="h6">
                        {Strings.REPORT.PHOTO_REPORT}
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <MultipleImageUploader
                        mode={mode}
                        optimize={false}
                        defaultValue={[...data?.photoUrls || []]}
                        folderPath={Constants.CloudStorage.REPORT_PHOTO}
                        onChange={(val) => {
                            handleChangeValue("photoUrls", val);
                        }}
                    />
                </Grid>
            </Grid>
        </Card>
    );
}

export default CardPhotoReport;